import * as action from './holidayAction'
import { default as actionType } from './holidayActionType'
import { default as reducer } from './holidayReducer'

export const HOLIDAY = {
  action,
  actionType,
  reducer
}
